import contentful, {
  flattenEntryResponse,
  flattenEntryResponseSingle,
} from '@aletheia/common/lib/contentful'

import { IFund } from '../types/generated'

/**
 * Fetch a single Fund from Contenful
 *
 * @param {string} slug The slug of the Fund you wish to fetch
 */
export const fetchFund = async (slug: string): Promise<IFund | undefined> => {
  return flattenEntryResponseSingle(
    await contentful.getEntries({
      content_type: 'fund',
      'fields.slug': slug,
      include: 5,
    }),
  ) as IFund | undefined
}

/**
 * Fetch all Funds from Contentful
 *
 * @param {object} query Options to pass to contentful.getEntries()
 */
export const fetchFunds = async (
  query?: Record<string, unknown>,
): Promise<IFund[]> => {
  return flattenEntryResponse(
    await contentful.getEntries({
      include: 5,
      ...query,
      content_type: 'fund',
    }),
  ) as IFund[]
}
